import { render, staticRenderFns } from "./SearchAutocomplete.vue?vue&type=template&id=c3a56408&scoped=true"
import script from "./SearchAutocomplete.vue?vue&type=script&lang=js"
export * from "./SearchAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./SearchAutocomplete.vue?vue&type=style&index=0&id=c3a56408&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../.npm/_npx/14f5bcddd9f17f34/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a56408",
  null
  
)

export default component.exports